<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
// import Dropzone from "@/components/c-dropzone";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import ServiceRow from "../../../../components/manage-sevice-row";
import { propertyServiceService } from "../../../../services/managements/propertyservice/propertyservice.service";

import { rentRecordService } from "../../../../services/managements/rents/rentrecord.service";
import { propertyService } from "../../../../services/managements/propertyservice/property.service";
import { customerService } from "../../../../services/contactservice/customer.service";
import { service } from "../../../../services/managements/services/service";
import moment from 'moment'
import i18n from "../../../../i18n";
import Loading from "@/components/c-loading";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Rent Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    Button,
    Input,
    Select,
    Search,
    ServiceRow
  },
  data() {
    return {
      dropdownSelection: {},
   
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Rent Request",
      breadCrumb: {},


      projectData: {},
      propertyData: {},
      customerData: {},
      serviceData: {},
      modifiedServiceData: {},
      propertyServiceData: {},
      roomStatusData: [
        {id:2, label: 'ស្នើជួល (Booking)'},
        {id:3, label: 'ចូលស្នាក់នៅ (Stay)'}
      ],
      monthlyBillingDateList: [
        {id: 1, label: 'ថ្ងៃទី 01'},
        {id: 2, label: 'ថ្ងៃទី 02'},
        {id: 3, label: 'ថ្ងៃទី 03'},
        {id: 4, label: 'ថ្ងៃទី 04'},
        {id: 5, label: 'ថ្ងៃទី 05'},
        {id: 6, label: 'ថ្ងៃទី 06'},
        {id: 7, label: 'ថ្ងៃទី 07'},
        {id: 8, label: 'ថ្ងៃទី 08'},
        {id: 9, label: 'ថ្ងៃទី 09'},
        {id: 10, label: 'ថ្ងៃទី 10'},
        {id: 11, label: 'ថ្ងៃទី 11'},
        {id: 12, label: 'ថ្ងៃទី 12'},
        {id: 13, label: 'ថ្ងៃទី 13'},
        {id: 14, label: 'ថ្ងៃទី 14'},
        {id: 15, label: 'ថ្ងៃទី 15'},
        {id: 16, label: 'ថ្ងៃទី 16'},
        {id: 17, label: 'ថ្ងៃទី 17'},
        {id: 18, label: 'ថ្ងៃទី 18'},
        {id: 19, label: 'ថ្ងៃទី 19'},
        {id: 20, label: 'ថ្ងៃទី 20'},
        {id: 21, label: 'ថ្ងៃទី 21'},
        {id: 22, label: 'ថ្ងៃទី 22'},
        {id: 23, label: 'ថ្ងៃទី 23'},
        {id: 24, label: 'ថ្ងៃទី 24'},
        {id: 25, label: 'ថ្ងៃទី 25'},
        {id: 26, label: 'ថ្ងៃទី 26'},
        {id: 27, label: 'ថ្ងៃទី 27'},
        {id: 28, label: 'ថ្ងៃទី 28'},
        {id: 29, label: 'ថ្ងៃទី 29'},
        {id: 30, label: 'ថ្ងៃទី 30'},
        {id: 31, label: 'ថ្ងៃទី 31'}
      ],
      user: JSON.parse(localStorage.getItem('user')),

      dataProjectId: 1,
      dataLastProjectId: 0,
      dataPropertyId: 0,
      dataPropertyName: '',
      dataCustomerId: 0,
      dataWatterRecord: '',
      dataElectrictRecord: '',
      dataMonthlyBillingDate: 0,
      dataPrice: 0,
      dataStartDate: '',
      dataBookingStayDate: '',
      dataEndDate: '',
      dataBookingNotation: '',
      dataBookingAmount: 0,
      dataRoomStatusId: 2,
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);     
    }
  },
 
  methods: {
    loadingData: function(id) {
      this.fetchingStats = true;
      propertyService.getOne(id)
        .then(response => {
          if(id != 0){
            this.dataProjectId = response.data.project_id;
            this.propertyData = response.data;
            this.dataPropertyId = this.propertyData.id
            this.dataPropertyName = this.propertyData.code
            this.dataMonthlyBillingDate = this.propertyData.monthly_billing_date ? this.propertyData.monthly_billing_date : 0
           
          }
          this.loadingSettings(response.setting);
          this.loadingCustomerData();
          this.loadServiceData(id);
        });

    },

    loadingSettings: function(setting) {
      this.projectData = {data: setting.projects};
      this.propertyData = {data: setting.properties};
    },

    loadingCustomerData: function() {
      let param = '?page=0';
      customerService.getList(param)
        .then(response => {
          this.customerData = response.data;
        });
    },

    loadServiceData:  function(id, param = '?page=0') {
      service.getList(param)
        .then(response => {
          let currentData = response.data;
          this.serviceData = currentData;
          this.loadServiceByPropertyId(id);
        });
       
    },

    loadServiceByPropertyId: function(id, param = '?page=0'){
      param = `?page=0&clause={"clause":[{"conjuction":"and","mg_property_services.property_id":{"value":${id}}}]}`;
      propertyServiceService.getList(param)
        .then(response => {
          if(id != 0){
            this.propertyServiceData = response.data;
            let selected_services = this.propertyServiceData.map((item) => item.service_id);
            if(this.serviceData){
              this.serviceData.map((item, i)=>{
                let check = selected_services.includes(item.id);
                this.serviceData[i].check = check;
                this.serviceData[i].quantity = check ? (this.propertyServiceData[i].quantity) : 1;
                this.serviceData[i].service_for = this.propertyServiceData[i].service_for;
                this.modifiedServiceData = this.serviceData;

              });
              this.getBillDate();
            }

          }
        });
    },

    getBillDate: function(){
      this.propertyServiceData.map((item, i)=>{
        this.serviceData.map((s, k)=>{
          if(item.service_id == s.id){
            this.serviceData[k].monthBilling = this.propertyServiceData[i].billing_cycle_date;
          }
        });
      });
    },

    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "manage-property"
          });

        }
      });
    
    },
    submitSave: function() {
      
      this.tryingToSubmit = true;
     
      let list = [];
      Object.keys(this.$refs).map(el => {
        // console.log(this.$refs[el]);
        if('getItem' in this.$refs[el][0]) {
          let item = (this.$refs[el][0]).getItem();
          if(item != null && item.check) {
            list.push(item);
          }
        }
      });

      let dataSubmit = {
        project_id : this.dataProjectId,
        property_id : this.dataPropertyId,
        customer_id : this.dataCustomerId,
        created_by : this.user.id,
        watter_record : this.dataWatterRecord!=""?this.dataWatterRecord:0,
        electrict_record : this.dataElectrictRecord!=""?this.dataElectrictRecord:0,
        monthly_billing_date: this.dataMonthlyBillingDate,
        price : this.dataPrice,
        booking_staty_date : this.dataBookingStayDate,
        start_date : this.dataStartDate,
        end_date : this.dataEndDate,
        room_status_id: this.dataRoomStatusId,
        booking_notation: this.dataBookingNotation,
        booking_amount: this.dataBookingAmount,
        services: list
      }

      console.log(dataSubmit);
      // validate data 
      // if(this.user.id==100){
      if(!(list.length && this.dataCustomerId && this.dataWatterRecord && this.dataElectrictRecord && this.dataStartDate && this.dataEndDate) && this.dataRoomStatusId == 3){
        this.$swal.fire({
          title: i18n.t('general.invalid.title'),
          text: 'បញ្ចូលព័ត៌មានមិនត្រឹមត្រូវ សូមពិនិត្យឡើងវិញ',
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.ok'),
        }).then(result => {
          return result ? false : false;
        });
       this.tryingToSubmit = false;
      }else if(this.dataRoomStatusId == 2 && (this.dataBookingStayDate=="" || this.dataCustomerId==0)){
        this.$swal.fire({
          title: i18n.t('general.invalid.title'),
          text: 'បញ្ចូលព័ត៌មានមិនត្រឹមត្រូវ សូមពិនិត្យឡើងវិញ',
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.ok'),
        }).then(result => {
          return result ? false : false;
        });
       this.tryingToSubmit = false;
      }else{
         rentRecordService.insert(dataSubmit)
         .then(response => {
           this.tryingToSubmit = false;
            // console.log(response);
           if(response.status == 200) {
              this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.ok'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
               console.log(result);
              if (result.value && this.dataRoomStatusId == 3) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-invoice-generate",
                  params:  {id: response.data.property_id},
                });
              }else{
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-property",
                });
                 
              }
            });
           }
          
        });
      
      
      }
      // }


    },


    clearForm: function() {

      this.dataProperty = 0;

    },

  },
};
</script>

<template>
  <Layout>
    <div>
      <PageHeader :items="[{
        text: $t('property.text'),
        href: '/manage/property',
      }, {
        text: $t('manage.room-status.rent-request'),
        active: true
      }]" :title="$t('manage.room-status.rent-request')" />
    </div>
    

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              
            <div class="row">
                <div class="col-md-4">
                <Select
                  @change="projectChanged" 
                  :id="'project_id'"
                  :disabled="true"
                  v-model="dataProjectId"
                  :list="this.projectData"
                  :label="'property.project'"
                  :require="true"
                    /> 
              </div>
              <div class="col-lg-4">
                <Input 
                  :id="'property_id'"
                  :disabled="true"
                  v-model="dataPropertyName"
                  :label="'property.text'" 
                />
              </div>
              <div class="col-sm">
                  <Search 
                    :text="'name'"
                    :id="'customer_id'"
                    :editable="false"
                    v-model="dataCustomerId"
                    :list="{data: customerData}"
                    :require="true"
                    :label="'customer.text'"  />
              </div>
            </div>

            <div class="row" v-if="this.dataRoomStatusId == 3">
              <div class="col-sm-4">
                <Input 
                  :type="'number'"
                  :id="'watter_record'"
                  :require="true"
                  v-model="dataWatterRecord"
                  :label="'manage.utility.watter'" 
                />
              </div>
              <div class="col-sm-4">
                <Input 
                  :type="'number'"
                  :id="'watter_record'"
                  :require="true"
                  v-model="dataElectrictRecord"
                  :label="'manage.utility.electrict'" 
                />
              </div>
              <div class="col-sm-4">
                <Select
                  :id="'monthly_billing_date'"
                  v-model="dataMonthlyBillingDate"
                  :list="{data:monthlyBillingDateList}"
                  :label="'manage.monthly-billing-date'"
                  :require="true"
                  /> 
              </div>
              
            </div>

            <div class="row"  v-if="this.dataRoomStatusId == 3">
              <div class="col-sm-4">
                <Select
                  :id="'room_status_id'"
                  v-model="dataRoomStatusId"
                  :list="{data:roomStatusData}"
                  :label="'ស្ថានភាព'"
                  :require="true"
                  /> 
              </div>
              <div class="col-sm-4">
                 <Input 
                  :type="'date'"
                  :id="'start_date'"
                  :require="true"
                  v-model="dataStartDate"
                  :label="'ចូលស្នាក់នៅចាប់ពីថ្ងៃទី'" 
                />
              </div>
              <div class="col-sm-4">
                 <Input 
                  :type="'date'"
                  :id="'end_date'"
                  :require="true"
                  v-model="dataEndDate"
                  :label="'បញ្ចប់ការស្នាក់នៅនៅថ្ងៃទី'" 
                />
              </div>
            </div>

             <div class="row"  v-if="this.dataRoomStatusId == 2">
              <div class="col-sm-4">
                <Select
                  :id="'room_status_id'"
                  v-model="dataRoomStatusId"
                  :list="{data:roomStatusData}"
                  :label="'ស្ថានភាព'"
                  :require="true"
                  /> 
              </div>
              <div class="col-sm-4">
                 <Input 
                  :type="'date'"
                  :id="'booking_stay_date'"
                  :require="true"
                  v-model="dataBookingStayDate"
                  :label="'ថ្ងៃចូលស្នាក់នៅ'" 
                />
              </div>
              <div class="col-sm-4">
                <Input 
                  :type="'text'"
                  :id="'notation'"
                  v-model="dataBookingNotation"
                  :label="'ចំណាំ'" 
                />
              </div>
            </div>

            <div class="row"  v-if="this.dataRoomStatusId == 3">
              <div class="col-sm">
                <div class="row border-top pt-3 bg-light">
                  <div class="col-sm-1">
                    <p class="">ជ្រើសរើស</p>
                  </div>
                  <div class="col-sm">
                    <p class="">សម្រាប់</p>
                  </div>
                  <div class="col-sm-3">
                    <p class="">{{$t('manage.service.name')}}{{$t('manage.service.text')}}</p>
                  </div>
                  <div class="col-sm-2">
                    <p class="">{{$t('manage.billing_cycle_date')}}({{$t('manage.yearly')}})</p>
                  </div>
                  <div class="col-sm">
                     <p class="">{{$t('invoice.quantity')}}</p>
                  </div>
                  <div class="col-sm">
                    <p class="">{{$t('invoice.price')}}</p>
                  </div>
                  <div class="col-sm">
                    <p class="">{{$t('invoice.total')}}</p>
                  </div>
                </div>
                <!-- <ServiceRow v-for="(item, index) in serviceData" :key="index" :ref="'service_' + index"
                  :item="item"
                  :index="index+1"
                  :billingDateSelectable="item.service_type_id==1?true:false"
                /> -->

                <ServiceRow v-for="(item, index) in modifiedServiceData" :key="index" :ref="'service_' + index"
                  :item="item"
                  :index="index+1"
                  :lookServiceFor="true"
                />
              </div>
            </div>
 
   
            <br>
            <div class="row">
              <div class="col-lg-12">

                <div inline class="row gy-2 gx-3 align-items-end">
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-x-circle'" 
                      v-bind:buttonType="'button'"
                      v-bind:variant="'danger'"
                      @click="submitCancel()"
                      v-bind:title="$t('general.cancel')"  />
                  </div>
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-save bx-tada'" 
                      v-bind:buttonType="'button'"
                      @click="submitSave()"
                      v-bind:requesting="tryingToSubmit"
                      v-bind:title="$t('general.save')"  />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </b-form> 
  </Layout>
</template>